export const OGP_IMAGE_DIMENSIONS = { width: 1200, height: 630 }
